import { Button, TextField } from '@mui/material';
import { useInputState } from 'lib/hooks/useInputState';
import { isEmptyString } from 'lib/typeguards';
import React from 'react';
import { Row } from 'ui/Flex';

interface TransactionsLastFourFilterProps {
    onChange: (value?: string) => void;
    value?: string;
    disabled?: boolean;
    size?: 'small' | 'medium';
    paper?: boolean;
}

function isLastFour(value: string) {
    const exp = new RegExp(/^([0-9]{4})$/);
    return isEmptyString(value) || exp.test(value);
}

export const TransactionsLastFourFilter: React.FC<TransactionsLastFourFilterProps> = ({
    value = '',
    onChange,
    disabled,
    paper,
    size
}) => {
    const [field, handleChange] = useInputState(value);
    const handleClick = React.useCallback(() => {
        onChange(isEmptyString(field) ? undefined : field);
    }, [field, onChange]);
    const renderButton = React.useCallback(
        () => (
            <Button
                disabled={value === field || !isLastFour(field) || disabled}
                onClick={handleClick}
                size={size}
                sx={{ mr: size === 'small' ? -1 : 0 }}
                variant="outlined"
            >
                {value === field || field.length ? 'Submit' : 'Clear'}
            </Button>
        ),
        [disabled, field, handleClick, size, value]
    );
    return (
        <Row>
            <TextField
                variant="outlined"
                value={field}
                onChange={handleChange}
                size={size}
                sx={{ backgroundColor: paper ? 'background.paper' : undefined }}
                label="Filter by card (last 4)"
                disabled={disabled}
                InputProps={{ endAdornment: renderButton() }}
            />
        </Row>
    );
};
